import React from 'react';
const stats = [{
  value: '+300',
  label: 'docentes y directivos'
}, {
  value: '7',
  label: 'módulos y bonos'
}, {
  value: '260+',
  label: 'páginas listas'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export function Stats() {
  return <section className="bg-[#FF6B35] py-4 md:py-6 border-b border-white/10" data-id="element-185">
      <div className="container mx-auto px-4" data-id="element-186">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8 text-center text-white" data-id="element-187">
          {stats.map((stat, i) => <div key={i} data-id="element-188">
              <p className="font-poppins font-black text-3xl md:text-4xl mb-1" data-id="element-189">
                {stat.value}
              </p>
              <p className="font-poppins text-[10px] md:text-xs uppercase tracking-wider font-bold opacity-90" data-id="element-190">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}